/**
 * Map CoC timezone strings to an IANA zone dayjs.tz can load.
 *
 * USPS writes compact offsets like ``UTC-0400``; the previous parser only
 * accepted ``UTC-4`` / ``UTC-04:00``, then passed ``UTC-0400`` through and
 * ``dayjs.tz`` threw RangeError on the share page.
 */
export function normalizeShareTimezone(tz?: string): string | undefined {
  if (!tz) return undefined;
  const cleaned = tz.trim();
  if (!cleaned) return undefined;
  if (/^utc$/i.test(cleaned)) return 'UTC';

  const compact = cleaned.match(/^utc([+-])(\d{2})(\d{2})$/i);
  const colon = cleaned.match(/^utc([+-])(\d{1,2}):(\d{2})$/i);
  const hoursOnly = cleaned.match(/^utc([+-])(\d{1,2})$/i);

  let sign: string | undefined;
  let hours = 0;
  let minutes = 0;
  if (compact) {
    sign = compact[1];
    hours = Number(compact[2]);
    minutes = Number(compact[3]);
  } else if (colon) {
    sign = colon[1];
    hours = Number(colon[2]);
    minutes = Number(colon[3]);
  } else if (hoursOnly) {
    sign = hoursOnly[1];
    hours = Number(hoursOnly[2]);
  } else {
    return cleaned
      .split('/')
      .map((seg) => (seg ? seg[0].toUpperCase() + seg.slice(1) : seg))
      .join('/');
  }

  if (hours === 0 && minutes === 0) return 'UTC';
  // Etc/GMT only supports whole-hour offsets.
  if (minutes !== 0) return undefined;
  const invertedSign = sign === '+' ? '-' : '+';
  return `Etc/GMT${invertedSign}${hours}`;
}
